<span *ngIf="data.length === 0" style="color: rgba(0, 0, 0, 0.6);">{{'NO-TASKS' | translate}}</span>
<div *ngIf="loading" class="row">
  <div class="col">
    <span class="k-icon k-i-loading kendo-loading-icon"></span>
  </div>
</div>
<div style="max-height: 75px; overflow-y: auto; overflow-x: hidden;">
  <div class="row" *ngFor="let d of data">
    <div class="col-7 cursor-default" title="{{d.description}}">
      <a [routerLink]="['/task', d.id]" class="pointer">
        {{d.name}}
      </a>
    </div>
    <div class="col-5 text-right">
      <span *ngIf="d.dueDate">
        {{'DUE-ON' | translate }}&nbsp;{{ intl.formatDate(intl.parseDate(d.dueDate), "g") }}
      </span>
    </div>
  </div>

</div>
<button kendoButton [primary]="true" type="button" (click)="createTask()" class="mt-3 mb-2 float-right">
  {{'ADD-FOLLOWUP-TASK' | translate}}<i class="far fa-plus"></i>
</button>

<!--add task dialog-->
<app-task-add [dialogOpened]="isNewTask" [memberId]="memberId" [caseId]="caseId" [followUpTaskId]="taskId"
  [channelId]="channelId" (cancelling)="isNewTask=false;" (save)="afterTaskAdded()">
</app-task-add>